export const implementationPrivateRoutesConstants = {
  root: {
    path: "/r/app/implementation",
    href: (projectId?: string) => `/r/app/implementation?project=${projectId}`
  }
};
